import { useState } from "react";
import { RECEIPTS } from "./data";
import { Kicker, DownloadReceiptBtn } from "./ui";

export const ReceiptsGallery = () => {
    const [open, setOpen] = useState(null);

    return (
        <section data-testid="receipts-gallery">
            <Kicker>Journey Receipts</Kicker>
            <h2 className="mt-2 text-2xl font-medium tracking-tight text-slate-900">
                Six receipt types connect the change to installation, acceptance and
                service outcome
            </h2>
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-slate-600">
                Each material transition produces an attributable receipt identifying
                the issuing role, the decision, evidence references, the package
                version, the previous and resulting state and any exception. Receipts
                are bounded proofs — never the underlying private records. Every
                receipt is downloadable as synthetic JSON.
            </p>

            <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                {RECEIPTS.map((r, i) => (
                    <div
                        key={r.key}
                        className="flex flex-col rounded-sm border border-slate-200 bg-white p-5"
                        data-testid={`receipt-card-${r.key}`}
                    >
                        <p className="text-sm font-medium text-slate-900">
                            {i + 1}. {r.name}
                        </p>
                        <p className="mt-2 text-xs font-medium uppercase tracking-wide text-slate-400">Proves</p>
                        <ul className="mt-1 space-y-0.5 text-sm text-slate-600">
                            {r.proves.map((p) => <li key={p}>· {p}</li>)}
                        </ul>
                        <div className="mt-4 flex flex-1 items-end justify-between gap-2">
                            <button
                                onClick={() => setOpen(open === r.key ? null : r.key)}
                                data-testid={`view-receipt-${r.key}`}
                                className="text-xs font-medium text-blue-950 underline underline-offset-2"
                            >
                                {open === r.key ? "Hide JSON" : "View JSON"}
                            </button>
                            <DownloadReceiptBtn
                                json={r.json}
                                filename={`${r.key}-receipt.json`}
                                testId={`download-receipt-${r.key}`}
                                label="Download"
                            />
                        </div>
                        {open === r.key && (
                            <pre
                                className="mt-3 max-h-64 overflow-auto rounded-sm bg-slate-900 p-3 text-[11px] leading-relaxed text-slate-100"
                                data-testid={`receipt-json-${r.key}`}
                            >
                                {JSON.stringify(r.json, null, 2)}
                            </pre>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};
